module.exports = __webpack_public_path__ + "img/login.2748768d.png";